import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// ============================================================
// ★ MOCKUP UI SAHAJA — "MODE PRO" — panel sidebar workspace
// (nama fail lama PilihanGayaMockPanel dikekalkan buat masa ni —
//  komponen sebenar Fasa 1 nanti dinamakan betul)
// Tiada logic sebenar: TIADA Firestore, TIADA localStorage,
// TIADA kesan pada Generate. State lokal je (hilang bila reload).
// Dirender admin-only dari App.jsx → selamat walaupun terdeploy.
//
// v6 (2026-07-26): panel jadi SATU rumah untuk semua setting PRO,
//     dan kini dipapar untuk SEMUA module (dulu AI8SAAT sahaja).
//     • Blok HOOK  — pilih Group dari Hook Bank (semua module).
//     • Blok GAYA  — pilih template gaya (AI8SAAT dulu).
//     Suis Auto/PRO menentukan sumber:
//       Auto → GOYANG guna sistem fragment asal; module lain AI tentukan.
//       PRO  → ikut Group hook user (fragment asal GOYANG dilangkau).
//     Sidebar = GUNA sahaja. Semua kerja setting di /pro-studio.
// ============================================================

// Demo data — nanti dari Firestore users/{uid}; ⭐ = Default Peribadi
const DEMO_TEMPLATES = [
  { name: 'Supplement Style', mode: 'perset', isDefault: true },
  { name: 'Produk Dapur',     mode: 'all',    isDefault: false },
];
const MAX_TEMPLATES = 5; // nanti: ikut lesen (trial 1, paid default 5) — mekanik sama maxProfiles avatar

const DEMO_GROUPS = [
  { name: 'Hook Mak-Mak Urgency', usage: 'adapt',    count: 4, isDefault: false },
  { name: 'Hook Simpanan Aku',    usage: 'verbatim', count: 3, isDefault: true  },
];
const MAX_GROUPS = 3; // ikut lesen: Premium 3 · Fighter 6 (mekanik sama maxProfiles)

const USAGE_SHORT = { adapt: 'AI tiru gaya contoh', verbatim: 'Tampal bulat-bulat' };

// Module yang seksyen Gaya dah sedia (selebihnya: hook sahaja buat masa ni)
const GAYA_READY = new Set(['ai8saat']);

const MODULE_NAME = {
  ai8saat: 'AI8SAAT', ai16saat: 'AI16SAAT', homeniche: 'Home Niche',
  goyang: 'GOYANG', smartcustom: 'Smart Custom', flownity: 'FLOWNITY',
};

export default function PilihanGayaMockPanel({ moduleId = 'ai8saat' }) {
  const navigate = useNavigate();
  const [proOn, setProOn] = useState(false);
  // Default Peribadi auto terpilih bila buka workspace
  const [selectedTpl, setSelectedTpl] = useState(DEMO_TEMPLATES.find(t => t.isDefault)?.name || '');
  const [selectedGrp, setSelectedGrp] = useState(DEMO_GROUPS.find(g => g.isDefault)?.name || '');

  const isGoyang = moduleId === 'goyang';
  const gayaReady = GAYA_READY.has(moduleId);
  const moduleName = MODULE_NAME[moduleId] || moduleId;

  const templates = DEMO_TEMPLATES;
  const groups = DEMO_GROUPS;
  const tplQuotaFull = templates.length >= MAX_TEMPLATES;
  const grpQuotaFull = groups.length >= MAX_GROUPS;
  const current = templates.find(t => t.name === selectedTpl);
  const currentGrp = groups.find(g => g.name === selectedGrp);

  const quotaChip = (full, now, max) => ({
    fontSize: 9, fontWeight: 800, padding: '2px 6px', borderRadius: 4, whiteSpace: 'nowrap',
    color: full ? '#ef4444' : '#6366f1',
    background: full ? '#fef2f2' : '#f5f3ff',
    border: `1px solid ${full ? '#fee2e2' : '#e0e7ff'}`,
  });

  const selectStyle = (has) => ({
    flex: 1, minWidth: 0, padding: '7px 8px', fontSize: 11, fontWeight: 600,
    background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: 8,
    color: has ? '#1e293b' : '#94a3b8', outline: 'none', cursor: 'pointer', boxSizing: 'border-box',
  });

  return (
    <div style={{
      border: `1.5px solid ${proOn ? '#6366f1' : '#c7d2fe'}`,
      borderRadius: 12, overflow: 'hidden',
      boxShadow: proOn ? '0 0 0 3px rgba(99,102,241,0.08)' : 'none',
      transition: 'all 0.2s',
    }}>

      {/* ── Header: tajuk + chip mockup + toggle Auto/PRO ── */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 6, padding: '10px 12px',
        background: proOn ? 'linear-gradient(135deg,#eef2ff 0%,#fafaff 100%)' : '#fafaff',
      }}>
        <span className="material-symbols-outlined" style={{ fontSize: 15, color: '#6366f1' }}>bolt</span>
        <span style={{ fontSize: 10, fontWeight: 800, color: '#334155', letterSpacing: '0.04em', textTransform: 'uppercase' }}>Mode PRO</span>
        <span style={{
          fontSize: 8, fontWeight: 900, letterSpacing: '0.08em', color: '#d97706',
          background: '#fffbeb', border: '1px solid #fde68a', padding: '1px 6px', borderRadius: 999,
        }}>MOCKUP</span>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 10, fontWeight: 800, color: proOn ? '#6366f1' : '#94a3b8', minWidth: 32, textAlign: 'right' }}>
            {proOn ? 'PRO' : 'Auto'}
          </span>
          <button
            type="button"
            role="switch"
            aria-checked={proOn}
            onClick={() => setProOn(x => !x)}
            title={proOn ? 'Kembali ke mod Auto (tetapan asal SESAAT)' : 'Aktifkan Mode PRO — guna hook & gaya anda sendiri'}
            style={{
              position: 'relative', width: 36, height: 20, borderRadius: 999, border: 'none',
              cursor: 'pointer', padding: 0, flexShrink: 0,
              background: proOn ? '#6366f1' : '#cbd5e1', transition: 'background 0.18s',
            }}
          >
            <span style={{
              position: 'absolute', top: 2, left: proOn ? 18 : 2, width: 16, height: 16,
              borderRadius: '50%', background: '#fff', boxShadow: '0 1px 2px rgba(0,0,0,0.25)',
              transition: 'left 0.18s',
            }} />
          </button>
        </div>
      </div>

      {/* ── Mod AUTO (PRO off): nota ikut module + teaser ── */}
      {!proOn && (
        <div style={{ padding: '10px 12px', background: '#ffffff', fontSize: 11, color: '#64748b', lineHeight: 1.5 }}>
          {isGoyang ? (
            <>Hook diambil daripada <b style={{ color: '#475569' }}>sistem fragment asal</b> GOYANG. Gaya ditentukan AI secara automatik.</>
          ) : (
            <>AI menentukan hook dan gaya terbaik secara automatik mengikut produk anda.</>
          )}
          <br />
          Aktifkan <b style={{ color: '#4338ca' }}>Mode PRO</b> untuk guna hook &amp; gaya anda sendiri.
        </div>
      )}

      {/* ── PRO AKTIF: pilih Hook Group + Gaya + link PRO Studio ── */}
      {proOn && (
        <div style={{ padding: 12, background: '#ffffff', display: 'flex', flexDirection: 'column', gap: 12 }}>

          {/* ══ BLOK HOOK — semua module ══ */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <span className="material-symbols-outlined" style={{ fontSize: 13, color: '#6366f1' }}>anchor</span>
              <span style={{ fontSize: 10, fontWeight: 800, color: '#475569', letterSpacing: '0.03em' }}>HOOK</span>
              <span style={{ fontSize: 8.5, fontWeight: 700, color: '#94a3b8' }}>· dari Hook Bank</span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <select
                value={selectedGrp}
                onChange={(e) => setSelectedGrp(e.target.value)}
                style={selectStyle(!!selectedGrp)}
              >
                <option value="">— Pilih group —</option>
                {groups.map(g => (
                  <option key={g.name} value={g.name}>
                    {g.isDefault ? '⭐ ' : ''}{g.name}
                  </option>
                ))}
              </select>
              <span style={quotaChip(grpQuotaFull)}>{groups.length}/{MAX_GROUPS}</span>
            </div>

            {currentGrp ? (
              <div style={{ fontSize: 9.5, color: '#94a3b8', fontWeight: 600, lineHeight: 1.5 }}>
                {USAGE_SHORT[currentGrp.usage]} · rawak antara {currentGrp.count} contoh setiap Generate.
                {currentGrp.isDefault ? ' ⭐ Default Peribadi anda.' : ''}
              </div>
            ) : (
              <div style={{ fontSize: 9.5, color: '#f59e0b', fontWeight: 600, lineHeight: 1.5 }}>
                Tiada group dipilih — hook akan ikut tetapan Default SESAAT.
              </div>
            )}

            {/* Nota ke mana hook mendarat + amaran khas GOYANG */}
            {currentGrp && (
              isGoyang ? (
                <div style={{
                  fontSize: 9.5, color: '#92600a', background: '#fffbeb',
                  border: '1px dashed #f2d38b', borderRadius: 8, padding: '7px 9px', lineHeight: 1.5,
                }}>
                  <b>Nota GOYANG:</b> sistem fragment hook asal anda <b>dilangkau</b> selagi Mode PRO hidup.
                  Tutup suis untuk kembali guna fragment asal.
                </div>
              ) : (
                <div style={{ fontSize: 9, color: '#cbd5e1', fontWeight: 600, lineHeight: 1.5 }}>
                  Hook menjadi ayat pembuka caption TikTok.
                </div>
              )
            )}
          </div>

          {/* ══ BLOK GAYA — AI8SAAT dulu ══ */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, paddingTop: 10, borderTop: '1px dashed #eef2f7' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <span className="material-symbols-outlined" style={{ fontSize: 13, color: gayaReady ? '#6366f1' : '#cbd5e1' }}>palette</span>
              <span style={{ fontSize: 10, fontWeight: 800, color: gayaReady ? '#475569' : '#94a3b8', letterSpacing: '0.03em' }}>GAYA</span>
              {!gayaReady && (
                <span style={{
                  fontSize: 7.5, fontWeight: 900, letterSpacing: '0.06em', color: '#94a3b8',
                  background: '#f1f5f9', padding: '2px 5px', borderRadius: 4,
                }}>SOON</span>
              )}
            </div>

            {gayaReady ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <select
                    value={selectedTpl}
                    onChange={(e) => setSelectedTpl(e.target.value)}
                    style={selectStyle(!!selectedTpl)}
                  >
                    <option value="">— Pilih template —</option>
                    {templates.map(t => (
                      <option key={t.name} value={t.name}>
                        {t.isDefault ? '⭐ ' : ''}{t.name}{t.mode === 'perset' ? '  (ikut set)' : ''}
                      </option>
                    ))}
                  </select>
                  <span style={quotaChip(tplQuotaFull)}>{templates.length}/{MAX_TEMPLATES}</span>
                </div>

                {current ? (
                  <div style={{ fontSize: 9.5, color: '#94a3b8', fontWeight: 600, lineHeight: 1.5 }}>
                    {current.mode === 'perset'
                      ? 'Template ini ada setting berbeza untuk Set 1 / 2 / 3.'
                      : 'Template ini guna setting sama untuk semua set.'}
                    {current.isDefault ? ' ⭐ Default Peribadi anda.' : ''}
                  </div>
                ) : (
                  <div style={{ fontSize: 9.5, color: '#f59e0b', fontWeight: 600, lineHeight: 1.5 }}>
                    Tiada template dipilih — gaya akan ikut tetapan Default SESAAT.
                  </div>
                )}
              </>
            ) : (
              <div style={{ fontSize: 9.5, color: '#94a3b8', fontWeight: 600, lineHeight: 1.5 }}>
                Setting gaya untuk {moduleName} akan datang. Buat masa ini gaya ditentukan AI.
              </div>
            )}
          </div>

          {/* Pautan ke page setting luas — sidebar utk GUNA, PRO Studio utk SETTING */}
          <button
            type="button"
            onClick={() => navigate('/prostudio')}
            style={{
              width: '100%', padding: '7px 8px', borderRadius: 8, cursor: 'pointer',
              fontSize: 10, fontWeight: 800,
              background: 'linear-gradient(135deg,#eef2ff 0%,#f5f3ff 100%)',
              border: '1px solid #c7d2fe', color: '#4338ca',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
            }}
          >
            <span className="material-symbols-outlined" style={{ fontSize: 13 }}>open_in_new</span>
            Urus penuh di PRO Studio
          </button>
        </div>
      )}
    </div>
  );
}
